import styled from 'styled-components';

import fonts from 'theme/fonts';
import promoColors from 'theme/promoColors';

const getBackground = (props) => {
    if (props.isDisabled) {
        return promoColors.gray40;
    } else if (props.isSelected) {
        return promoColors.primary;
    } else {
        return promoColors.purple5;
    }
};
const getColor = (props) => {
    if (props.isDisabled || props.isSelected) {
        return promoColors.white;
    } else if (props.isInactive) {
        return promoColors.gray80;
    } else {
        return promoColors.primary;
    }
};

export const Container = styled.div`
    font-family: ${fonts.regular};
    font-size: 12px;
    line-height: 16px;
    background-color: ${(props) => getBackground(props)};
    color: ${(props) => getColor(props)};
    display: inline-flex;
    padding: 8px 16px;
    border-radius: 4px;
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: ${(props) => (props.isDisabled || props.isInactive || props.isSelected ? 'default' : 'pointer')};

    &:hover {
        background: ${(props) => (props.isDisabled || props.isInactive || props.isSelected ? null : promoColors.purple20)};
    }

    &:focus-visible {
        outline: 1px dashed ${(props) => (props.isDisabled || props.isInactive || props.isSelected ? null : promoColors.purple)};
    }
`;
